module.exports = __webpack_public_path__ + "static/sport/bgi-form.effc227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/bgi-form.png
// module id = GdKx
// module chunks = 0